<script>
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  MailIcon,
} from "vue-feather-icons";
import axios from "axios";
import { API_URL, MEDIA_URL } from "@/core/api";

export default {
  metaInfo: function() {
    return {
      title: "404 - Find Your Dream Job - job4u.pk",
      meta: [
        {
          name: "description",
          content:
            "Find your dream and latest Jobs in Pakistan from top recruiters, employers and companies in all over the Pakistan. Search and apply online now",
        },
      ],
    };
  },
  data() {
    
  },
  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    MailIcon,
  },
  mounted() {
    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);
    
  },
  methods: {
    toggleMenu_barger() {
      this.isCondensed = !this.isCondensed;
      if (this.isCondensed) {
        document.getElementById("navigation").style.display = "block";
      } else document.getElementById("navigation").style.display = "none";
    },
  },
};
</script>

<template>
  <div class="mt-17">
    <div>
      <Navbar />
    </div>
    <div class="_404_background_img">
      <div class="container" style="margin: 0 auto">
        <div class="row">
          <div class="col-12 text-center heading">
            OOPS!
          </div>
          <div class="col-12 text-center text">
            Link broken or page missing
          </div>
          <div class="col-12 text-center">
            <img src="/images/404/404.svg" alt="404 place holder image">
          </div>
          <div class="col-12 text-center">
            <button> <a class="text-white" href="/"> Back to homepage</a></button>
          </div>

        </div>
      </div>
    </div>
    <Footer />
    <Switcher />
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-soft-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
</style>

<script>

// FormValidation plugins
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";

import KTUtil from "@/assets/js/components/util";
import Switcher from "@/view/front/components/switcher";
import Footer from "@/view/front/components/footer";
import Navbar from "@/view/front/components/navbar";
import { mapGetters, mapState } from "vuex";
import { LOGIN, LOGOUT, REGISTER } from "@/core/services/store/auth.module";
import Swal from "sweetalert2";
import axios from "axios";
import { API_URL } from "@/core/api";
import { initFbsdk } from "@/core/config/facebook.js";

export default {
  name: "login-1",
  data() {
    return {
      recruiterSignUp: false,
      agencySignUp: false,
      apiUrl: API_URL,
    };
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    ...mapGetters(["currentUser"]),

    backgroundImage() {
      return (
        process.env.BASE_URL + "media/svg/illustrations/login-visual-1.svg"
      );
    },
  },
  mounted() {
    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);

    initFbsdk();
  },
  components: {
    Navbar,
    Switcher,
    Footer,
  },
  methods: {
    
  },
};
</script>
<style scoped>
footer span,
footer a,
footer p,
footer h4,
footer label {
  color: white !important;
}
</style>
